<div class="main-section">
  <form>
      <div class="form">
          <div class="">
              <mat-radio-group [formControl]="annualIncome" aria-label="Select an option"
                  (change)="getSalarySlab($event)">
                  <mat-label>Your Annual Income</mat-label>
                  <div class="row">
                      <div class="col-xs-6" *ngFor="let item of annualIncomeList">
                          <mat-radio-button [value]="item.id">{{item?.ammout}}</mat-radio-button>
                      </div>
                  </div>
              </mat-radio-group>
              <mat-error *ngIf="errorCheck">
                  <span>*</span>
                  Kindly Select Annual Income
              </mat-error>
          </div>
      </div>
  </form>
  <div class="note" *ngIf="clientStatus != 'A'">
      <span class="error-text">Dear User, Your Account is Dormant. Please contact customer support at <a
              href="mailto:support&#64;5paisa.com">support&#64;5paisa.com</a></span>
  </div>
  <div class="bottom-button-wrapper btn" *ngIf="!btnLoader">
      <button type="button" class="btn--primary" [disabled]="clientStatus != 'A' || this.annualIncome.invalid"
          (click)="submit()">{{btnText}}</button>
  </div>
  <div class="bottom-button-wrapper btn" *ngIf="btnLoader">
      <button class="btn btn--primary">
          <span class="stage">
              <span class="dot-pulse"></span>
          </span>
      </button>
  </div>
</div>